import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './star.features';
import { themeColors } from './star.config';
import { StarSportsLogotype } from './star.logotype';
import { StarSportsLogo } from 'src/layouts/LoginPage/logos/StarSportsLogo';
import StarLoginImage from 'src/layouts/LoginPage/loginBgImages/StarLoginImage.jpg';
import { StarBrandIconWrapper, CompliancePopupLogo } from './star.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'GPP Star Backoffice',
    urls: {
        website: 'https://starsports.bet/',
        backoffice: 'star-backoffice.sherbetcloud.com/',
    },
    BrandIcon: () => <StarBrandIconWrapper />,
    Logotype: () => <StarSportsLogotype />,
    LogotypeLoginPage: () => <StarSportsLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={StarLoginImage} />,
};
